"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step/Step"));
var _StepConnector = _interopRequireDefault(require("@material-ui/core/StepConnector"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel/StepLabel"));
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _Typography = _interopRequireDefault(require("../../Typography"));
function Fixed(_ref) {
  var activeStep = _ref.activeStep,
    classes = _ref.classes,
    error = _ref.error,
    isFixedThin = _ref.isFixedThin,
    orientation = _ref.orientation,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    stepContent = _ref.stepContent;
  var direction = orientation === 'vertical' ? 'row' : 'column';
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: direction,
    classes: {
      root: classes.gridRoot
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    classes: {
      root: classes.gridItemRoot
    }
  }, isFixedThin ? /*#__PURE__*/_react["default"].createElement(_MobileStepper["default"], {
    classes: {
      root: classes.stepThinRoot
    },
    position: "static",
    backButton: null,
    nextButton: null,
    steps: stepContent.length + 1,
    activeStep: activeStep + 1,
    variant: "progress"
  }) : /*#__PURE__*/_react["default"].createElement(_Stepper["default"], {
    activeStep: activeStep,
    classes: {
      root: classes.stepRoot
    },
    orientation: orientation,
    connector: /*#__PURE__*/_react["default"].createElement(_StepConnector["default"], {
      classes: {
        horizontal: classes.stepConnectorHoriz,
        vertical: classes.stepConnectorVert
      }
    })
  }, stepContent.map(function (step, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(_Step["default"], {
        key: "".concat(step.title, "-").concat(index)
      }, /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], {
        error: error === index,
        classes: {
          iconContainer: classes.stepIcon,
          labelContainer: classes.stepLabel
        }
      }, "\xA0"))
    );
  }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: classes.stepContentRoot
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    style: {
      lineHeight: '24px'
    }
  }, stepContent[activeStep].stepTitle), /*#__PURE__*/_react["default"].createElement("section", {
    className: classes.stepContentBody
  }, stepContent[activeStep].contentBody), /*#__PURE__*/_react["default"].createElement("section", {
    className: classes.stepActionBar
  }, secondaryButton, primaryButton)));
}
Fixed.propTypes = process.env.NODE_ENV !== "production" ? {
  activeStep: _propTypes["default"].number.isRequired,
  classes: _propTypes["default"].object.isRequired,
  error: _propTypes["default"].number.isRequired,
  isFixedThin: _propTypes["default"].bool.isRequired,
  orientation: _propTypes["default"].string.isRequired,
  primaryButton: _propTypes["default"].element.isRequired,
  secondaryButton: _propTypes["default"].element.isRequired,
  stepContent: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired
} : {};
var _default = Fixed;
exports["default"] = _default;